import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './BankInfoDataForm.html?raw';
import on from 'dojo/on';
import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import Button from '../../../moreCore/UI/Button/Button';
import CollapsibleSection from '../CollapsibleSection/CollapsibleSection';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import Edit from '../../../moreCore/UI/Edit/Edit';

class BankInfoDataForm extends compose(_WidgetBaseSP) {
    templateString: any = template;
    isReadonly: boolean = false;
    isDirty: boolean = false;

    AccountNumberInput: MdsLax<InstanceType<typeof Edit>>;
    IbanInput: MdsLax<InstanceType<typeof Edit>>;

    BankHintBox: MdsLax<InstanceType<typeof HintBox>>;
    BicSwiftInput: MdsLax<InstanceType<typeof Edit>>;
    SortCodeInput: MdsLax<InstanceType<typeof Edit>>;
    BankNameInput: MdsLax<InstanceType<typeof Edit>>;
    BankAddressInput: MdsLax<InstanceType<typeof Edit>>;
    CountryInput: MdsLax<InstanceType<typeof SearchSelect>>;

    saveNewBankAccountBtn: MdsLax<InstanceType<typeof Button>>;
    newBankAccountErrorContainer: HTMLElement;
    newBankAccountErrorMessage: HTMLElement;

    newBankSectionMessageContainer: HTMLElement;
    newBankSectionMessage: HTMLElement;

    allBankAccounts: Array<IndividualData_BankInfo>;

    bankAccountSelect: MdsLax<InstanceType<typeof SelectBox>>;
    btn_setAsActiveInactive: HTMLElement;
    btn_setAsMain: HTMLElement;
    selectedBankAccountInfoContainer: HTMLElement;

    readonlyIsActive: HTMLInputElement;
    readonlyIsMainAccount: HTMLInputElement;
    readonlyBankName: HTMLInputElement;
    readonlyBankAddress: HTMLInputElement;
    readonlyBankAccount: HTMLInputElement;
    readonlySortCode: HTMLInputElement;
    readonlyIban: HTMLInputElement;
    readonlyBic: HTMLInputElement;

    bankDataFormErrorContainer: HTMLElement;
    bankDataFormErrorMessage: HTMLElement;

    newPassportContainer: HTMLElement;

    formData: IndividualData_BankBranchSave = {
        account_no: "",
        IBAN: "",
        bank_id: "",
        bank_BIC: "",
        bank_number: "",
        bank_name: "",
        city: "",
        country: ""
    };
    originalData: string = "";

    loadFormData(data: Array<IndividualData_BankInfo>): void {

        this.prepareBankAccountsSection(data);

        this.createNewBankAccoundSection();

    //    this.serializeFormData();

    //    this.originalData = JSON.stringify(this.formData);
    //    console.debug(this.originalData);
    }

    prepareBankAccountsSection(data: Array<IndividualData_BankInfo>, refreshAcc?: string): void {

       this. _showErrorMessage(false);

        this.allBankAccounts = data;
        this.allBankAccounts.length > 0 ? this.bankAccountSelect.setPlaceholder(this.translations["FormLabel_BankAccount_placeholder"]) : this.bankAccountSelect.setPlaceholder(this.translations["FormLabel_BankAccount_Placeholder_empty"]);

        this.bankAccountSelect.clear();

        let accId: string = "";

        data.forEach(acc => {

            this.bankAccountSelect.addOption(acc.ID, `${acc.ref_bank.bank_name} - ${acc.IBAN}`);
            if (acc.is_default_business_account) accId = acc.ID;
        });

        this.bankAccountSelect.constructOptions();
        if (refreshAcc) this.bankAccountSelect.setValue(refreshAcc, true);
        else if (accId) this.bankAccountSelect.setValue(accId, true);

        this.constructAccountInfo(accId);
    }

    constructAccountInfo(accId: string): void {

        let acc: IndividualData_BankInfo = this.allBankAccounts.filter(x => x.ID === accId)[0];

        if (acc) {

            this.UiModder.domClass.remove(this.selectedBankAccountInfoContainer, "w3-hide");

            if (acc.is_active) {

                this.readonlyIsActive.value = this.translations["General_Yes"];
                this.btn_setAsActiveInactive.innerHTML = this.translations["Btn_SetAsInactive"];
                this.UiModder.domAttr.set(this.btn_setAsActiveInactive, "attr_set_active_inactive", "set_inactive");
            } else {

                this.readonlyIsActive.value = this.translations["General_No"];
                this.btn_setAsActiveInactive.innerHTML = this.translations["Btn_SetAsActive"];
                this.UiModder.domAttr.set(this.btn_setAsActiveInactive, "attr_set_active_inactive", "set_active");

            }

            if (acc.is_default_business_account) {

                this.readonlyIsMainAccount.value = this.translations["General_Yes"];
                this.UiModder.domClass.add(this.btn_setAsMain, "w3-hide");
            } else {

                this.readonlyIsMainAccount.value = this.translations["General_No"];
                this.UiModder.domClass.remove(this.btn_setAsMain, "w3-hide");
            }

            this.readonlyBankName.value = acc.ref_bank.bank_name;
            this.readonlyBankAddress.value = acc.ref_bank.city;
            this.readonlyBankAccount.value = acc.account_no;
            this.readonlySortCode.value = acc.ref_bank.bank_number;
            this.readonlyIban.value = acc.IBAN;
            this.readonlyBic.value = acc.ref_bank.bank_BIC;


        } else {

            this.UiModder.domClass.add(this.selectedBankAccountInfoContainer, "w3-hide");
        }

        this.bankAccountSelect.StandbyStop();
    }

    createNewBankAccoundSection(): void {

        //INPUTS INIT
        this.AccountNumberInput = new Edit();
        this.IbanInput = new Edit();

        this.BankHintBox = new HintBox();
        this.BankHintBox.setCyName("BankInfoData:Bank");
        this.BicSwiftInput = new Edit();
        this.BicSwiftInput.setCyName("BankInfoData:BicSwift");
        this.SortCodeInput = new Edit();
        this.SortCodeInput.setCyName("BankInfoData:SortCode");
        this.BankNameInput = new Edit();
        this.BankNameInput.setCyName("BankInfoData:BankName");
        this.BankAddressInput = new Edit();
        this.BankAddressInput.setCyName("BankInfoData:BankAddress");
        this.CountryInput = new SearchSelect();
        this.CountryInput.setCyName("BankInfoData:CountryInput");

        this.saveNewBankAccountBtn = new Button();
        this.saveNewBankAccountBtn.setCyName("BankInfoData:saveNewBankAccountBtn");


        this.UiModder.domConstruct.empty(this.newPassportContainer);

        let cs = new CollapsibleSection();

        cs.sectionName = "new_bank_account_section";
        cs.isEditable = false;
        cs.collapsibleHeading.innerHTML = this.translations["FormLabel_Collapsible_NewBankAccount"];
        cs.placeAt(this.newPassportContainer);

        this.UiModder.domConstruct.empty(cs.collapsibleContainer);

        // account_no
        let div = this.UiModder.domConstruct.create("div", { class: "w3-container w3-padding" }, cs.collapsibleContainer);

        this.AccountNumberInput.setLabel(this.translations["FormLabel_Bank_AccountNumber"]);
        this.AccountNumberInput.setMandatory(true);
        this.UiModder.domClass.add(this.AccountNumberInput.domNode, "w3-half");
        this.AccountNumberInput.placeAt(div);

        on(this.AccountNumberInput, "change", lang.hitch(this, this._onChange_newBankAddressData));

        // IBAN
        div = this.UiModder.domConstruct.create("div", { class: "w3-container w3-padding" }, cs.collapsibleContainer);

        this.IbanInput.setLabel(this.translations["FormLabel_Bank_Iban"]);
        this.IbanInput.setMandatory(true);
        this.UiModder.domClass.add(this.IbanInput.domNode, "w3-half");
        this.IbanInput.placeAt(div);

        on(this.IbanInput, "change", lang.hitch(this, this._onChange_newBankAddressData));

        // BANK
        div = this.UiModder.domConstruct.create("div", { class: "w3-container w3-padding" }, cs.collapsibleContainer);

        this.BankHintBox.setLabel(this.translations["FormLabel_Bank_BankSectionHeader"]);
        this.BankHintBox._setPlaceholderAttr(this.translations["FormLabel_Bank_HintBox_Placeholder"]);
        this.BankHintBox.minLetterCount = 3;
        this.BankHintBox.dataFormat = "json";
        this.BankHintBox.setLabelAttribute("gDisp_1");
        this.BankHintBox.requestUrlSearchParameter = "searchText";
        this.BankHintBox.setUrl("IndividualDataSheet/GetBanksHintboxValues");
        this.BankHintBox.resetOnEdit = true;
        //this.UiModder.domClass.add(this.BankHintBox.domNode, "w3-half");
        this.BankHintBox.placeAt(div);
        this.BankHintBox.setMaxResultsCount(100);

        on(this.BankHintBox, "valueChange", lang.hitch(this, this._onChange_BankHintBox));

        this.newBankSectionMessageContainer = this.UiModder.domConstruct.create("div", {
            class: "w3-row w3-padding w3-round w3-pale-yellow w3-text-deep-purple w3-hide flex_row_center",
            style: "flex-wrap:nowrap"
        }, div);

        this.UiModder.domConstruct.create("div", {
            innerHTML: `<i class="fa fa-exclamation w3-margin-right">&nbsp;</i>`
        }, this.newBankSectionMessageContainer);

        this.newBankSectionMessage = this.UiModder.domConstruct.create("div", {
            innerHTML: this.translations["IndividualDataSheet_BankData_BankMessage"]
        }, this.newBankSectionMessageContainer);

        let bankDiv = this.UiModder.domConstruct.create("div", {
            class: "w3-container w3-padding"
        }, div);

        // BIC
        this.BicSwiftInput.setLabel(this.translations["FormLabel_Bank_Bic"]);
        this.BicSwiftInput.setReadonly(true);
        this.UiModder.domClass.add(this.BicSwiftInput.domNode, "w3-row w3-padding");
        this.UiModder.domClass.add(this.BicSwiftInput.labelNode, "w3-col m2");
        this.UiModder.domClass.add(this.BicSwiftInput.inputNode, "w3-quarter");
        this.BicSwiftInput.placeAt(bankDiv);
        on(this.BicSwiftInput, "change", lang.hitch(this, this._onChange_newBankAddressData));
            

        // BLZ
        this.SortCodeInput.setLabel(this.translations["FormLabel_Bank_BankSortCode"]);
        this.SortCodeInput.setReadonly(true);
        this.UiModder.domClass.add(this.SortCodeInput.domNode, "w3-row w3-padding");
        this.UiModder.domClass.add(this.SortCodeInput.labelNode, "w3-col m2");
        this.UiModder.domClass.add(this.SortCodeInput.inputNode, "w3-quarter");
        this.SortCodeInput.placeAt(bankDiv);
        on(this.SortCodeInput, "change", lang.hitch(this, this._onChange_newBankAddressData));

        // Descr
        this.BankNameInput.setLabel(this.translations["FormLabel_Bank_BankName"]);
        this.BankNameInput.setReadonly(true);
        this.UiModder.domClass.add(this.BankNameInput.domNode, "w3-row w3-padding");
        this.UiModder.domClass.add(this.BankNameInput.labelNode, "w3-col m2");
        this.UiModder.domClass.add(this.BankNameInput.inputNode, "w3-twothird");
        this.BankNameInput.placeAt(bankDiv);
        on(this.BankNameInput, "change", lang.hitch(this, this._onChange_newBankAddressData));

        // Address
        this.BankAddressInput.setLabel(this.translations["FormLabel_Bank_BankAddress"]);
        this.BankAddressInput.setReadonly(true);
        this.UiModder.domClass.add(this.BankAddressInput.domNode, "w3-row w3-padding");
        this.UiModder.domClass.add(this.BankAddressInput.labelNode, "w3-col m2");
        this.UiModder.domClass.add(this.BankAddressInput.inputNode, "w3-twothird");
        this.BankAddressInput.placeAt(bankDiv);
        on(this.BankAddressInput, "change", lang.hitch(this, this._onChange_newBankAddressData));

        // Country
        let countryRow = this.UiModder.domConstruct.create("div", { class: "w3-row w3-padding" }, bankDiv)
        this.CountryInput.valueAttribute = "ID";
        this.CountryInput.labelAttribute = "description";
        this.CountryInput.setDropDownPositionAbsolute(false);
        this.CountryInput.setUrl("IndividualDataSheet/GetCountryListValues");
        this.CountryInput._setReadonlyAttr(true);

        this.UiModder.domConstruct.create("label", { innerHTML: this.translations["FormLabel_Country"], class: "w3-col m2" }, countryRow);
        this.UiModder.domClass.add(this.CountryInput.domNode, "w3-quarter");
        this.CountryInput.loadListValues();
        this.CountryInput.placeAt(countryRow);
        on(this.CountryInput, "change", lang.hitch(this, this._onChange_newBankAddressData));

        // BTN
        div = this.UiModder.domConstruct.create("div", { class: "w3-container w3-padding" }, cs.collapsibleContainer);

        this.saveNewBankAccountBtn.setLabel(this.translations["General_Save"]);
        this.saveNewBankAccountBtn.setClasses("mds-button-base w3-padding w3-disabled round mds-hover-bright accentBG", " ");
        this.saveNewBankAccountBtn.setIconLeft("fas fa-save");
        this.saveNewBankAccountBtn.on("click", lang.hitch(this, this._onClick_saveBtn));
        this.saveNewBankAccountBtn.placeAt(div);

        //Error container
        this.newBankAccountErrorContainer = this.UiModder.domConstruct.create("div", {
            class: "w3-container w3-padding w3-round w3-pale-red w3-text-red w3-hide flex_row_center w3-margin",
            style: "flex-wrap:nowrap"
        }, cs.collapsibleContainer);

        this.UiModder.domConstruct.create("div", {
            class: "w3-text-red",
            innerHTML: '<i class="fa fa-exclamation-triangle">&nbsp;</i>'
        }, this.newBankAccountErrorContainer);

        this.newBankAccountErrorMessage = this.UiModder.domConstruct.create("div", {}, this.newBankAccountErrorContainer);


    }

    serializeFormData(): void {

        let b: boolean = true;

        this.formData.account_no = this.AccountNumberInput.getValue();
        if (!this.formData.account_no) b = false;

        this.formData.IBAN = this.IbanInput.getValue();
        if (!this.formData.IBAN) b = false;

        let bank: string | IndividualData_PostalCode = this.BankHintBox.getValue();

        switch (typeof (bank)) {
            case "object":

                bank ? this.formData.bank_id = bank.ID : this.formData.bank_id = "";
                break;
            default:

                this.formData.bank_id = "";
                break;
        }

        this.formData.bank_BIC = this.BicSwiftInput.getValue();
        if (!this.formData.bank_BIC) b = false;

        this.formData.bank_number = this.SortCodeInput.getValue();
        if (!this.formData.bank_number) b = false;

        this.formData.bank_name = this.BankNameInput.getValue();
        if (!this.formData.bank_name) b = false;

        this.formData.city = this.BankAddressInput.getValue();
        if (!this.formData.city) b = false;

        this.formData.country = this.CountryInput.getValue();
        //if (!this.formData.country) b = false;

        if (b) {

            this.saveNewBankAccountBtn.setClasses(" ", "w3-disabled");
            this._showNewAddressErrorMessage(false);
        } else {

            this.saveNewBankAccountBtn.setClasses("w3-disabled", " ");
        }

        console.debug("SERIALIZE DATA:", this.formData);
    }

    setBankAccountAsActiveInactive(dlgResult: any): void {

        if (dlgResult === 2) {

            let requestUrl = window.appRoot + "IndividualDataSheet/SetBankAccountAsActiveInactive";
            this.StandbyStart();

            this.RequestManager.post(
                requestUrl,
                {
                    accountId: this.bankAccountSelect.getValue()
                },
                lang.hitch(this, this._onSetBankAccountAsActiveInactiveResponse),
                lang.hitch(this, this._onSetBankAccountAsActiveInactiveError),
                false // sync
            );
        }
    }

    setBankAccountAsStandard(dlgResult): void {

        if (dlgResult === 2) {

            let requestUrl = window.appRoot + "IndividualDataSheet/SetBankAccountAsStandard";
            this.StandbyStart();

            this.RequestManager.post(
                requestUrl,
                {
                    accountId: this.bankAccountSelect.getValue()
                },
                lang.hitch(this, this._onSetBankAccountAsStandardResponse),
                lang.hitch(this, this._onSetBankAccountAsStandardError),
                false // sync
            );
        }
    }

    _onSetBankAccountAsActiveInactiveResponse(): void {

        this.refreshBankAccountsData();
    }

    _onSetBankAccountAsStandardResponse(): void {

        this.refreshBankAccountsData();
    }

    refreshBankAccountsData(): void {

        let requestUrl = window.appRoot + "IndividualDataSheet/GetSectionDataByName";

        this.RequestManager.post(
            requestUrl,
            {
                sectionName: IndividualData_SectionName.BankInfo
            },
            lang.hitch(this, this._onRefreshDataResponse),
            lang.hitch(this, this._onRefreshDataError),
            false // sync
        );
    }

    _onRefreshDataResponse(data: Array<IndividualData_BankInfo>): void {

        this.StandbyStop();
        let bankValue = this.bankAccountSelect.getValue();

        this.prepareBankAccountsSection(data, bankValue);
    }

    _onClick_saveBtn(): void {

        let requestUrl = window.appRoot + "IndividualDataSheet/SaveFormData";
        this.StandbyStart();

        this.RequestManager.post(
            requestUrl,
            {
                jsonData: JSON.stringify(this.formData),
                sectionName: IndividualData_SectionName.BankInfo
            },
            lang.hitch(this, this._onSaveNewBankResponse),
            lang.hitch(this, this._onSaveNewBankError),
            false // sync
        );
    }

    _onSaveNewBankResponse(response): void {

        this.createNewBankAccoundSection();
        this.refreshBankAccountsData();

        setTimeout(() => {
            this.bankAccountSelect.StandbyStart();
            this.bankAccountSelect.setValue(response.bankId);
            this.StandbyStop();
        }, 1500);
    }

    checkDirty(): void {

        this.isDirty = JSON.stringify(this.formData) !== this.originalData;

        this.emit("change_isDirty", this.isDirty);
    }

    _onChange_BankHintBox(): void {

        let hintboxValue = this.BankHintBox.getValue();

        switch (typeof (hintboxValue)) {
            case "object":

                this.BicSwiftInput.setReadonly(true);
                this.SortCodeInput.setReadonly(true);
                this.BankNameInput.setReadonly(true);
                this.BankAddressInput.setReadonly(true);
                this.CountryInput._setReadonlyAttr(true);


                // was soll das eigentlich...
                this.UiModder.domClass.add(this.newBankSectionMessageContainer, "w3-hide");
                this.UiModder.domClass.remove(this.BicSwiftInput.inputNode, "w3-pale-yellow");
                this.UiModder.domClass.remove(this.SortCodeInput.inputNode, "w3-pale-yellow");
                this.UiModder.domClass.remove(this.BankNameInput.inputNode, "w3-pale-yellow");
                this.UiModder.domClass.remove(this.BankAddressInput.inputNode, "w3-pale-yellow");
                //this.UiModder.domClass.remove(this.CountryInput.outerInput, "w3-pale-yellow");

                let bank: IndividualData_BankBranchDetails = this.BankHintBox.getValue();

                if (bank) this.BicSwiftInput.setValue(bank.bank_BIC, true);
                if (bank) this.SortCodeInput.setValue(bank.bank_number, true);
                if (bank) this.BankNameInput.setValue(bank.bank_name, true);
                if (bank) this.BankAddressInput.setValue(bank.city, true);
                if (bank) this.CountryInput.setValue(bank.ref_country?.ID, true);

                break;
            default:

                if (this.BankHintBox.getValue("entity") !== null && this.BankHintBox.getValue("value") !== null) {

                    this.BicSwiftInput.setReadonly(false);
                    this.SortCodeInput.setReadonly(false);
                    this.BankNameInput.setReadonly(false);
                    this.BankAddressInput.setReadonly(false);
                    this.CountryInput._setReadonlyAttr(false);

                    //
                    this.UiModder.domClass.remove(this.newBankSectionMessageContainer, "w3-hide");
                    this.UiModder.domClass.add(this.BicSwiftInput.inputNode, "w3-pale-yellow");
                    this.UiModder.domClass.add(this.SortCodeInput.inputNode, "w3-pale-yellow");
                    this.UiModder.domClass.add(this.BankNameInput.inputNode, "w3-pale-yellow");
                    this.UiModder.domClass.add(this.BankAddressInput.inputNode, "w3-pale-yellow");
                    //this.UiModder.domClass.add(this.CountryInput.outerInput, "w3-pale-yellow");

                    this.BicSwiftInput.setValue("");
                    this.SortCodeInput.setValue("");
                    this.BankNameInput.setValue("");
                    this.BankAddressInput.setValue("");
                    this.CountryInput.setValue("");
                }
                break;
        }

        this.serializeFormData();
    }

    _onChange_newBankAddressData(): void {

        this.serializeFormData();
    }

    _onChange_SelectedbankAccount(): void {

        this.constructAccountInfo(this.bankAccountSelect.getValue());
    }

    _onClick_setAsActiveInactiveBtn(): void {

        let mode = this.UiModder.domAttr.get(this.btn_setAsActiveInactive, "attr_set_active_inactive");
        let msg = "";

        switch (mode) {
            case "set_active":
                msg = this.translations["FormDialog_Form_setAsActive"];
                break;
            case "set_inactive":
                msg = this.translations["FormDialog_Form_setAsInaktive"];
                break;
        }

        let dlg = new GenericDialog();

        dlg.show(msg, this.translations["FormLabel_IsAktive"], null, "fas fa-question", "yesno", lang.hitch(this, this.setBankAccountAsActiveInactive));
        dlg.destroyOnClose = true;
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "width", "600px");
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "margin-top", "100px");
    }

    _onClick_setAsMainBtn(): void {

        let dlg = new GenericDialog();

        dlg.show(this.translations["FormDialog_Form_setAsStandardAccount"], this.translations["FormLabel_Bank_IsMainAccount"], null, "fas fa-question", "yesno", lang.hitch(this, this.setBankAccountAsStandard));
        dlg.destroyOnClose = true;
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "width", "600px");
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "margin-top", "100px");
    }

    _onSetBankAccountAsStandardError(err): void {

        this.StandbyStop();
        this._showErrorMessage(true, err.Message);
    }

    _onRefreshDataError(err): void {

        this.StandbyStop();
        this._showErrorMessage(true, err.Message);
    }

    _onSetBankAccountAsActiveInactiveError(err): void {

        this.StandbyStop();
        this._showErrorMessage(true, err.Message);
    }

    private _showErrorMessage(show: boolean, msg?: string): void {

        if (show) {

            this.UiModder.domClass.remove(this.bankDataFormErrorContainer, "w3-hide");
            msg ? this.bankDataFormErrorMessage.innerHTML = msg : this.bankDataFormErrorMessage.innerHTML = "...error occured";
        } else {

            this.UiModder.domClass.add(this.bankDataFormErrorContainer, "w3-hide");
            this.bankDataFormErrorMessage.innerHTML = "";
        }
    }

    _onSaveNewBankError(err) {

        this.StandbyStop();
        this._showNewAddressErrorMessage(true, err.Message);
    }

    private _showNewAddressErrorMessage(show: boolean, msg?: string): void {

        if (show) {

            this.UiModder.domClass.remove(this.newBankAccountErrorContainer, "w3-hide");
            msg ? this.newBankAccountErrorMessage.innerHTML = msg : this.newBankAccountErrorMessage.innerHTML = "...error occured";
        } else {

            this.UiModder.domClass.add(this.newBankAccountErrorContainer, "w3-hide");
            this.newBankAccountErrorMessage.innerHTML = "";
        }
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(BankInfoDataForm);